import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { CHECK_USER } from "../../common/queries/dashboard";
import useDashboardValidationHook from "./useDashboardValidationHook";
import useTranslation from "../common/useTranslation";

const useValidateClientName = (rawClientName) => {
  const { t } = useTranslation();
  const { getClientNameSchema } = useDashboardValidationHook();
  const schema = getClientNameSchema();

  const parsed = schema.safeParse(rawClientName);

  if (!parsed.success) {
    return {
      isValidClient: false,
      loading: false,
      error: null,
      validationError:
        parsed.error.errors[0]?.message ?? t("error.clientName.invalid"),
    };
  }

  const clientName = parsed.data;

  const { data, loading, error } = useQuery(CHECK_USER, {
    variables: { clientName },
    skip: !clientName,
  });

  useEffect(() => {
    if (
      data?.CheckClientLoginId === false &&
      !window.location.host.includes("aquilatrack")
    ) {
      localStorage.setItem("agreementDisplayed", "true");
    }
  }, [data]);

  return {
    isValidClient: data?.CheckClientLoginId ?? true,
    loading,
    error,
    validationError: null,
  };
};

export default useValidateClientName;
